import _slicedToArray from "/Users/francesco/Dropbox/Mac/Documents/GitHub/DFN-GRP-Web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { sync } from '../frameloop/index.mjs';
import { useState, useCallback } from 'react';
import { useIsMounted } from './use-is-mounted.mjs';
function useForceUpdate() {
  var isMounted = useIsMounted();
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    forcedRenderCount = _useState2[0],
    setForcedRenderCount = _useState2[1];
  var forceRender = useCallback(function () {
    isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
  }, [forcedRenderCount]);
  /**
   * Defer this to the end of the next animation frame in case there are multiple
   * synchronous calls.
   */
  var deferredForceRender = useCallback(function () {
    return sync.postRender(forceRender);
  }, [forceRender]);
  return [deferredForceRender, forcedRenderCount];
}
export { useForceUpdate };